import {Component, OnInit, Input} from '@angular/core';
import {User} from "../shared/model/user";
import {UserService} from "../shared/model/user.service";
import {FormGroup, FormBuilder, Validators, AbstractControl, FormControl} from "@angular/forms";
import {AbstractClassPart} from "@angular/compiler/src/output/output_ast";
import {AuthService} from "../shared/security/auth.service";
import {sleepMilliseconds} from "../shared/util/sleep-util";
import {TranslateService} from "@ngx-translate/core";


@Component({
    selector: 'user-add',
    templateUrl: './user-add.component.html',
    styleUrls: ['./user-add.component.css']
})
export class UserAddComponent implements OnInit {

    myForm: FormGroup;

    name: string;
    email: string;
    phone: string = "0...";
    role: string = "player";
    uid: string = "";
    intensity: number = 100;

    isSaved: boolean = false;
    hasError: boolean = false;
    message: string = "";

    public visibleAdd = true;
    private visibleAddAnimate = false;

    public roles = [
      {value: 'superadmin', display: 'Superadmin'},
      {value: 'admin', display: 'Administrator'},
      //{value: 'steward', display: 'Steward'},
      {value: 'trainer', display: 'Trainer'},
      {value: 'player', display: 'Player'}
    ];

  public intensities = [
    {value: 100, display: '100'},
    {value: 80, display: '80'},
    {value: 60, display: '60'}
  ];

    constructor(private fb: FormBuilder, private userService: UserService, private authService: AuthService, private translate: TranslateService) {
        this.myForm = fb.group({
            'name': ['', Validators.compose([Validators.required, Validators.minLength(6)])],
            'email': ['', Validators.compose([Validators.required, Validators.pattern('^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-zA-Z0-9-]+)*$')])],
            'phone': ['', Validators.compose([Validators.required, Validators.pattern('[0-9]*')])],
            'role': [''],
            'intensity': ['']
        });
    }

    ngOnInit() {
        //console.log("ngOnInit: UserAddComponent");
        this.show();
    }

    ngOnChanges() {
    }

    setUserRole(role: string) {
        this.role = role;
    }

    setIntensity(intensity: number) {
      this.intensity = intensity;
    }

    public show(): void {
        this.visibleAdd = true;
        setTimeout(() => this.visibleAddAnimate = true);
    }

    public hide(): void {
        this.visibleAddAnimate = false;
        setTimeout(() => this.visibleAdd = false, 300);
    }

    public save() {
      let clubId = this.authService.getClubIdForUser();
      this.authService.signUp(this.email, "!jk4Kl79BSZ", clubId, this.name, this.phone, this.role, this.intensity, this.userService);
      this.translate.get('s.useradded').subscribe((res: string) => {
        this.message = res;
        this.isSaved = true;
      });

    }


}

